/// <reference path="koyori.ts" />

/**
 * タブを表示します。
 * <dl>
 * <dt>属性</dt>
 * </dl>
 */
class KoyoriTabs extends KoyoriElement {

	connectedCallback(): void {
		super.connectedCallback();
		this.reLayout();

		KoyoriElement.querySelectorAll(this, 'koy-tab label').forEach(label => {
			label.addEventListener('click', event => {
				this.clickLabel(<HTMLElement>event.target);
			});
		});
	}

	/**
	 * タブのレイアウトを調整します。
	 */
	reLayout(): void {
		let activeExists = false;
		let left = 0;
		KoyoriElement.querySelectorAll(this, 'koy-tab>label').forEach(label => {
			label.style.left = left + 'px';
			left += label.offsetWidth;

			let tab = label.parentElement;
			if (tab.getAttribute('active') != null) {
				activeExists = true;
			} else if (activeExists) {
				setTimeout(() => {
					tab.removeAttribute('active');
				});
			}
		});
		if (activeExists == false) {
			setTimeout(() => {
				this.querySelector('koy-tab').setAttribute('active', '');
			});
		}
	}

	clickLabel(target: HTMLElement): void {
		let tab = target.closest('koy-tab');
		if (tab.getAttribute('active') != null) {
			return;
		}
		KoyoriElement.querySelectorAll(this, 'koy-tab').forEach(tab => {
			tab.removeAttribute('active');
		});
		tab.setAttribute('active', '');
	}

	/**
	 * @return 選択中タブエレメント
	 */
	getActiveTab(): KoyoriTab {
		return <KoyoriTab>this.querySelector('koy-tab[active]');
	}

	/**
	 * タブを選択します。
	 * 
	 * @param tab 選択するタブエレメント
	 */
	selectTab(tab: KoyoriTab): void {
		KoyoriElement.querySelectorAll(this, 'koy-tab').forEach(tab => {
			tab.removeAttribute('active');
		});
		tab.setAttribute('active', '');
	}

}
window.customElements.define('koy-tabs', KoyoriTabs);

/**
 * <dl>
 * <dt>属性</dt>
 * <dd>active: 開いているタブに付与されます</dd>
 * </dl>
 * <dl>
 * <dt>イベント</dt>
 * <dd>active: 開いた際に発生します</dd>
 * <dd>inactive: 閉じた際に発生します</dd>
 * </dl>
 */
class KoyoriTab extends KoyoriElement {

	static get observedAttributes() {
		return ['active'];
	}

	protected activeChanged(value: string): void {
		if (value == null) {
			KoyoriElement.fireEvent(this, 'inactive');
		} else {
			KoyoriElement.fireEvent(this, 'active');
		}
	}

}
window.customElements.define('koy-tab', KoyoriTab);
